import ProductPicker from "emun.products/picker/product-picker";
import templateUrl from "emun.swatch/swatchlist-header.htm";
import SwatchListPrompt from "emun.swatch/swatchlist-prompt";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import $session from "servicestack/session";

class SwatchListHeaderController {
  constructor($window, $rootScope, NgMap, $timeout) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$session = $session;
    $ctrl.bus = new ServiceBus();
  }
  edit() {
    //        return this.prompt.edit(this.count).then(() => this.container.query.load(true));
    SwatchListPrompt.open({ model: { list: this.list } }).then(() =>
      this.container.query.load(true)
    );
  }
  duplicate() {
    SwatchListPrompt.open({ model: { source: this.list } }).then(() =>
      $ctrl.load()
    );
  }
  downloadData() {
    let $ctrl = this;
    var url;
    if (this.list.listType.toUpperCase() == "STOCK")
      url = $ctrl.$appConfig.resolveServiceUrl(
        "RunReport?reportName=QuickReport&displayName=" +
          this.list.name +
          "&output=xlsx&QuickReportID=StockList" +
          "&QuickReportName=StockList" +
          "&@ListId=" +
          this.list.id
      );
    else
      url = $ctrl.$appConfig.resolveServiceUrl(
        "QuerySwatchListDetail.csv?ListId=" + this.list.id
      );

    return (location.href = url);
  }
  cleanCsvValue(value) {
    return value
      .replace(/^\s*|\s*$/g, "") // remove leading & trailing space
      .replace(/^"|"$/g, "") // remove " on the beginning and end
      .replace(/""/g, '"'); // replace "" with "
  }
  csvToJSON(content) {
    let $ctrl = this;
    var lines = content.csv.split(
      new RegExp('\n(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)')
    );
    var result = [];
    var start = 0;
    var columnCount = lines[0].split(content.separator).length;

    var headers = [];
    if (content.header) {
      headers = lines[0].split(content.separator);
      start = 1;
    }

    for (var i = start; i < lines.length; i++) {
      var obj = {};
      var currentline = lines[i].split(
        new RegExp(content.separator + '(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)')
      );
      if (currentline.length === columnCount) {
        if (content.header) {
          for (var j = 0; j < headers.length; j++) {
            obj[headers[j]] = $ctrl.cleanCsvValue(currentline[j]);
          }
        } else {
          for (var k = 0; k < currentline.length; k++) {
            obj[k] = $ctrl.cleanCsvValue(currentline[k]);
          }
        }
        result.push(obj);
      }
    }
    return result;
  }
  processFile(file) {
    let $ctrl = this;
    $ctrl.finished = false;
    $ctrl.filename = file.name;
    $ctrl.cleanFile = true;
    $ctrl.errors = [];
    $ctrl.swatches = [];
    $ctrl.errors.errorCodes = [];
    var reader = new FileReader();
    reader.onload = function (ev) {
      var content = {
        csv: ev.target.result.replace(/\r\n|\r/g, "\n"),
        header: true,
        separator: ",",
      };
      $ctrl.content = content.csv;
      $ctrl.result = $ctrl.csvToJSON(content);
      angular.forEach($ctrl.result, function (r) {
        $ctrl.swatches.push(
          r.SwatchId || r.SwatchID || r.ProductId || r.ProductID
        );
      });
      $ctrl.bus
        .send("ImportSwatchList.json", {
          ListId: $ctrl.list.id,
          swatches: $ctrl.swatches,
          ClearList: true,
        })
        .then(function (response) {
          $ctrl.container.detailQuery.load(true);
        });
    };
    reader.readAsText(file);
  }
  addProducts() {
    const $ctrl = this;
    const { productIds = [] } = $ctrl.container.productSelection;
    ProductPicker({
      title: "Select products for list...",
      view: "table",
      viewSelections: productIds.length > 0,
      applyTagsButtonText: false,
      selected: productIds.reduce(
        (m, id) => Object.assign(m, { [id]: true }),
        {}
      ),
    }).then(function (ids) {
      Object.assign($ctrl.container.productSelection, {
        productIds: Object.keys(ids),
      });
      $ctrl.bus
        .send("ImportSwatchList", {
          ListId: $ctrl.list.id,
          swatches: $ctrl.container.productSelection.productIds,
          ClearList: true,
        })
        .then(function (response) {
          $ctrl.container.detailQuery.load(true);
        });
    });
  }
  backToLists() {
    const $ctrl = this;
    if ($ctrl.list.listType.toUpperCase() == "STOCK") {
      $ctrl.$state.transitionTo("swatch.stock-lists", {
        listType: $ctrl.list.listType,
      });
    } else {
      $ctrl.$state.transitionTo("swatch.lists", {
        listType: $ctrl.list.listType,
      });
    }
  }
}

const SwatchListHeader = {
  bindings: {
    list: "<",
  },
  require: {
    container: "^swatchlistEdit",
  },
  controller: SwatchListHeaderController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};

export default SwatchListHeader;
